/**
 * Unified haptics utility.
 * Native: @capacitor/haptics (richer than Vibration API)
 * Web: web-haptics for semantic patterns (success, error, nudge, buzz)
 */

import { platform } from '@/utils/platform';

let webHapticsInstance: import('web-haptics').WebHaptics | null = null;

async function getWebHaptics() {
  if (!webHapticsInstance) {
    const { WebHaptics } = await import('web-haptics');
    if (WebHaptics.isSupported) {
      webHapticsInstance = new WebHaptics();
    }
  }
  return webHapticsInstance;
}

async function triggerNative(style: 'Light' | 'Medium' | 'Heavy' = 'Light') {
  const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
  Haptics.impact({ style: ImpactStyle[style] });
}

async function triggerWeb(pattern: string) {
  const wh = await getWebHaptics();
  wh?.trigger(pattern);
}

function fire(nativeStyle: 'Light' | 'Medium' | 'Heavy', webPattern: string) {
  if (platform.isNative) triggerNative(nativeStyle);
  else triggerWeb(webPattern);
}

export const haptic = {
  light: () => fire('Light', 'nudge'),
  heavy: () => fire('Heavy', 'heavy'),
  tick: () => fire('Light', 'selection'),
  success: () => fire('Medium', 'success'),
  error: () => fire('Heavy', 'error'),
  nudge: () => fire('Light', 'nudge'),
  buzz: () => fire('Medium', 'buzz'),
};

/** Backward compat — drop after migration */
export function triggerHapticFeedback(_pattern: number | number[] = 30) {
  haptic.light();
}
